// 広告トラッキング

document.addEventListener('DOMContentLoaded', () => {

  // ----------------------------------
  // 設定値
  // ----------------------------------
  const config = {
    impressionUrl: '/apps/jmedj_ext/api/ads/impression',
    clickUrl: '/apps/jmedj_ext/api/ads/click'
  };

  // ----------------------------------
  // 共通のイベントトラッキング用ヘルパー関数
  // ----------------------------------

  const trackEvent = (url, payload) => {
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(response => response.json());
  };

  // インプレッション計測（広告表示時の計測）
  const adElements = document.querySelectorAll('.ad-data');
  const impressionData = Array.from(adElements).map(el => ({
    ad_id: el.dataset.adId,
    max_views: Number(el.dataset.maxViews),
    max_clicks: Number(el.dataset.maxClicks),
    current_views: Number(el.dataset.currentViews),
    current_clicks: Number(el.dataset.currentClicks)
  }));

  if (impressionData.length > 0) {
    trackEvent(config.impressionUrl, impressionData)
      .then(data => {
        if (data.error) {
          console.error('Server error:', data.error);
        } else {
          console.log('Impression tracking response:', data);
        }
      })
      .catch(error => console.error('Impression tracking error:', error));
  }

  // クリック計測とリンク遷移
  adElements.forEach(el => {
    el.addEventListener('click', event => {
      event.preventDefault();
      const adId = el.dataset.adId;
      const maxViews = Number(el.dataset.maxViews);
      const maxClicks = Number(el.dataset.maxClicks);
      const currentViews = Number(el.dataset.currentViews);
      const currentClicks = Number(el.dataset.currentClicks);
      const target = el.getAttribute('target') || '_self';
      const payload = {
        ad_id: adId,
        max_views: maxViews,
        max_clicks: maxClicks,
        current_views: currentViews,
        current_clicks: currentClicks
      };

      trackEvent(config.clickUrl, payload)
        .then(data => {
          if (data.error) {
            console.error('Server error:', data.error);
          } else {
            console.log('Click tracking response:', data);
          }
          window.open(el.href, target);
        })
        .catch(error => console.error('Click tracking error:', error));
    });
  });

});
